<template>
    <div class="card" :class="jobListing.featured ? 'featured' : ''">
        <div class="card__main">
            <div class="card__logo">
                <div class="card__image-container">
                    <img :src="require('../assets/' + jobListing.imagePath)" />
                </div>
            </div>
            <div class="card__info">
                <div class="card__top">
                    <h5 class="card__company">{{ jobListing.company }}</h5>
                    <h5 v-if="jobListing.new" class="card__new main-tag">
                        NEW!
                    </h5>
                    <h5
                        v-if="jobListing.featured"
                        class="card__featured main-tag"
                    >
                        FEATURED
                    </h5>
                </div>
                <h3 class="card__title">{{ jobListing.jobTitle }}</h3>
                <div class="card__details">
                    <p>{{ jobListing.longAgo }}</p>
                    <div class="divider"></div>
                    <p>{{ jobListing.jobType }}</p>
                    <div class="divider"></div>
                    <p>{{ jobListing.location }}</p>
                </div>
            </div>
        </div>
        <div class="card__tags">
            <JobListing__tag
                v-for="tag in jobListing.tags"
                :key="jobListing.company + ' ' + tag"
                :tag="tag"
            />
        </div>
    </div>
</template>

<script>
import JobListing__tag from '@/components/JobListing__tag'
export default {
    props: ['jobListing'],
    components: {
        JobListing__tag,
    },
}
</script>

<style lang="scss">
.featured {
    border-left: 0.4rem solid var(--color-primary);
}

.divider {
    align-self: center;
    width: 0.2rem;
    height: 0.2rem;
    border-radius: 50%;
    background: black;
}

.main-tag {
    color: white;
    font-size: 0.8rem;
    border-radius: 1rem;
    padding: 0.4rem 0.4rem 0.2rem 0.4rem;
    margin: 0 0.5rem;
}

.card {
    @media (max-width: 600px) {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        &__tags {
            margin: 1rem 0;
        }
    }
    margin: 2.5rem 0;
    display: flex;
    justify-content: space-between;
    border-radius: 0.5rem;
    align-items: center;
    min-height: 10rem;
    width: 100%;
    padding: 1rem;
    background: white;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
        0 2px 4px -1px rgba(0, 0, 0, 0.06);
    &__new {
        background: var(--color-primary);
    }
    &__featured {
        background: var(--color-darker-gray-cyan);
    }
    &__top {
        display: flex;
        align-items: center;
    }
    &__image-container {
        width: 7.5rem;
        height: 7.5rem;
        border-radius: 50%;
        background-color: var(--color-primary);
        margin: 0 1.5rem;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
            border-radius: inherit;
        }
    }
    &__main {
        display: flex;
    }
    &__info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    &__title {
        font-size: 1.4rem;
        &:hover {
            color: var(--color-primary);
            cursor: pointer;
        }
    }
    &__company {
        color: var(--color-primary);
        font-size: 1.2rem;
    }
    &__details {
        display: flex;
    }
    &__details * {
        margin: 0 0.5rem;
        opacity: 0.5;
        font-size: 1rem;
    }
    &__details:first-child {
        margin-left: 0;
    }
}
</style>
